/**
 * Catalogue v1, first half of the route: Начало · Документы · Пуск · Кузов
 * (steps 1–15). Order within the array IS the route order.
 */
import { ALL_OUTCOMES, NOT_EV, NO_CAPTURE, photos, RECORD_ONLY_OUTCOMES, VIDEO_SECONDS, video, ZONES_FRONT, ZONES_GLASS, ZONES_LEFT, ZONES_LIGHTS, ZONES_PILLARS, ZONES_REAR, ZONES_RIGHT, ZONES_UNDERBODY, } from './catalogue.v1.parts.js';
const SIDE_CHIPS = ['paint_mismatch', 'filler', 'dent', 'rust', 'panel_gap', 'other'];
const side = (key, defect, chips = SIDE_CHIPS) => ({
    key,
    section: 'body',
    required: true,
    capture: photos(2, 'exterior'),
    chips,
    outcomes: ALL_OUTCOMES,
    defect,
    mediaVisibility: 'public',
});
export const V1_OUTSIDE = [
    // ------------------------------------------------------------- Начало
    {
        key: 'conditions',
        section: 'start',
        required: true,
        capture: NO_CAPTURE,
        chips: [],
        outcomes: RECORD_ONLY_OUTCOMES,
        value: { kind: 'conditions', required: true },
        mediaVisibility: 'public',
    },
    {
        key: 'engine_parking',
        section: 'start',
        required: true,
        capture: photos(1, 'undercarriage'),
        chips: ['fresh_leak_spot', 'other'],
        outcomes: ALL_OUTCOMES,
        value: { kind: 'engine_state', required: true },
        defect: { side: 'underbody', zones: ZONES_UNDERBODY },
        appliesTo: NOT_EV,
        mediaVisibility: 'public',
    },
    {
        key: 'overview',
        section: 'start',
        required: true,
        capture: photos(2, 'exterior'),
        chips: ['other'],
        outcomes: ALL_OUTCOMES,
        mediaVisibility: 'public',
    },
    // ---------------------------------------------------------- Документы
    {
        // D2: the VIN plate is on the car and in the listing — its photo is public.
        key: 'vin_plate',
        section: 'documents',
        required: true,
        capture: photos(2, 'exterior'),
        chips: ['vin_mismatch', 'vin_tampered', 'vin_plate_missing', 'other'],
        outcomes: ALL_OUTCOMES,
        mediaVisibility: 'public',
    },
    {
        // PRIV: техпаспорт photos never leave the owner — only the conclusions do.
        key: 'techpassport_keys',
        section: 'documents',
        required: true,
        capture: photos(2, 'document'),
        chips: [
            'docs_mismatch',
            'docs_duplicate',
            'owners_many',
            'single_key',
            'service_history_gap',
            'other',
        ],
        outcomes: ALL_OUTCOMES,
        value: { kind: 'documents', required: true },
        mediaVisibility: 'inspector_only',
    },
    // --------------------------------------------------------------- Пуск
    {
        key: 'dashboard',
        section: 'startup',
        required: true,
        capture: photos(1, 'interior'),
        chips: ['warning_lights', 'mileage_suspect', 'gauge_fault', 'other'],
        outcomes: ALL_OUTCOMES,
        value: { kind: 'odometer', required: false },
        mediaVisibility: 'public',
    },
    {
        key: 'cold_start',
        section: 'startup',
        required: true,
        capture: video(VIDEO_SECONDS.coldStart, 'engine'),
        chips: ['hard_start', 'engine_noise', 'smoke', 'rough_idle', 'warning_lights', 'other'],
        outcomes: ALL_OUTCOMES,
        appliesTo: NOT_EV,
        mediaVisibility: 'public',
    },
    {
        key: 'exhaust',
        section: 'startup',
        required: true,
        capture: video(VIDEO_SECONDS.exhaust, 'exterior'),
        chips: ['smoke_blue', 'smoke_white', 'smoke_black', 'exhaust_leak', 'other'],
        outcomes: ALL_OUTCOMES,
        defect: { side: 'underbody', zones: ['exhaust'] },
        appliesTo: NOT_EV,
        mediaVisibility: 'public',
    },
    // -------------------------------------------------------------- Кузов
    side('body_front', { side: 'front', zones: ZONES_FRONT }, [
        'paint_mismatch',
        'filler',
        'paint_chips',
        'dent',
        'panel_gap',
        'other',
    ]),
    side('body_left', { side: 'left', zones: ZONES_LEFT }),
    side('body_rear', { side: 'rear', zones: ZONES_REAR }),
    side('body_right', { side: 'right', zones: ZONES_RIGHT }),
    {
        ...side('roof', { side: 'roof', zones: ['roof', ...ZONES_PILLARS] }, [
            'paint_mismatch',
            'filler',
            'dent',
            'rust',
            'hail_damage',
            'other',
        ]),
        capture: photos(1, 'exterior'),
    },
    {
        ...side('glass', { side: 'glass', zones: ZONES_GLASS }, [
            'glass_crack',
            'glass_chip',
            'glass_replaced',
            'other',
        ]),
        capture: photos(1, 'exterior'),
    },
    side('lights', { side: 'lights', zones: ZONES_LIGHTS }, [
        'light_fault',
        'lens_fogged',
        'lens_damage',
        'other',
    ]),
];
//# sourceMappingURL=catalogue.v1.outside.js.map